/**BYZ-7377 : verbiage for FMCG and unique channel markets */
export const SubscriptionInfo = {
    SUBSCRITPION_EXPIRED: `Your Byzzer Contract has expired, Please contact your sales representative to upgrade/renew your Byzzer contract.`
};
export const CONTACT_SALES_REPRESENTATIVE_MESSAGE = 'To upgrade or modify your subscription with add-ons such as more categories, report runs, members, and premium markets please reach out to your Byzzer sales representative.';

export const BONUS_REPORT_SKU = ['449'];